import _omitBy from 'lodash/omitBy';
import _isNil from 'lodash/isNil';
import { authUtilityLoader } from '@consumer/auth-utility-loader';
let fetchPromise;
let fetchPromiseResolve;
let timeout;
const resolveConsumerProfile = async () => {
  const {
    accountAPIFetchJSON
  } = await authUtilityLoader();
  const consumerProfile = await accountAPIFetchJSON('/account-api/consumer');
  fetchPromiseResolve(_omitBy({
    myConsumerId: consumerProfile.consumerid,
    email: consumerProfile.email,
    phoneNumber: consumerProfile.phone
  }, _isNil));
  fetchPromise = undefined;
};
const debouncedGetConsumerProfile = () => {
  if (!fetchPromise) {
    fetchPromise = new Promise(res => {
      fetchPromiseResolve = res;
    });
  }
  clearTimeout(timeout);
  timeout = setTimeout(resolveConsumerProfile, 25);
  return fetchPromise;
};
const getConsumerMetadata = async () => {
  try {
    const {
      getIsUserSignedIn
    } = await authUtilityLoader();
    if (await getIsUserSignedIn()) {
      return debouncedGetConsumerProfile();
    }
  } catch {
    // no-op
  }
  return {};
};
export default getConsumerMetadata;